// extracted by mini-css-extract-plugin
export default {"title":"fgOEHN","dateLocation":"b6Z9By","LEFT":"iMDEQN","left":"iMDEQN","CENTER":"iQq22W","center":"iQq22W","RIGHT":"cmY6Y_","right":"cmY6Y_"};